export default __webpack_public_path__ + "static/media/023-space exploration.8bfc6687.svg";